import { render, staticRenderFns } from "./EntityList.vue?vue&type=template&id=794036b2&scoped=true"
import script from "./EntityList.vue?vue&type=script&lang=js"
export * from "./EntityList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794036b2",
  null
  
)

export default component.exports